import { DateTime, Info } from "luxon";


export const DEFAULT_TZ = "Asia/Seoul" as const;


export function localInputToIsoInstant(local: string, tz = DEFAULT_TZ): string {
  // 형식이 타임존을 안 담으므로, 우리가 원하는 IANA TZ로 해석
  const dt = DateTime.fromFormat(local, "yyyy-LL-dd'T'HH:mm", { zone: tz }); // fromFormat/fromISO는 공식 API
  if (!dt.isValid) throw new Error(`Invalid local datetime: ${local}`);
  return dt.toUTC().toISO({ suppressMilliseconds: true }); // "…Z"
}

export function isoInstantToLocalInput(iso: string, tz = DEFAULT_TZ): string {
  // 문자열에 오프셋이 있으면 그대로 존을 유지(setZone: true), 그 후 목표 TZ로 변환
  const dt = DateTime.fromISO(iso, { setZone: true }).setZone(tz); // setZone 옵션은 문서/이슈에서 명시
  if (!dt.isValid) throw new Error(`Invalid ISO: ${iso}`);
  return dt.toFormat("yyyy-LL-dd'T'HH:mm");
}
export function isoInstantToLocalDateInput(iso: string, tz = DEFAULT_TZ): string {
  // 문자열에 오프셋이 있으면 그대로 존을 유지(setZone: true), 그 후 목표 TZ로 변환
  const dt = DateTime.fromISO(iso, { setZone: true }).setZone(tz); // setZone 옵션은 문서/이슈에서 명시
  if (!dt.isValid) throw new Error(`Invalid ISO: ${iso}`);
  return dt.toFormat("yyyy-LL-dd");
}

export function formatDisplay(iso: string, tz = DEFAULT_TZ, locale = "ko"): string {
  const dt = DateTime.fromISO(iso, { setZone: true }).setZone(tz);
  return dt.setLocale(locale).toLocaleString(DateTime.DATETIME_MED_WITH_SECONDS);
}

export function assertValidIanaZone(tz: string) {
  if (!Info.isValidIANAZone(tz)) throw new Error(`Invalid IANA zone: ${tz}`);
}